import { create } from "zustand";


type StatisticsState = {
  users: UsersStatistics | null,
}

type StatisticsActions = {
  setUsersStatistics: (stat: UsersStatistics) => void;
}

const initialState: StatisticsState = {
  users: null,
}

export const useStatisticsStore = create<StatisticsState & StatisticsActions>((set) => ({

  ...initialState,

  setUsersStatistics: (stat) => set((state) => ({
    ...state, users: { ...stat },
  }))


}));